<template>
  <div class="toggle-wrapper">
    <i class='fa fa-sun'></i>
    <label class="toggle">
        <input type="checkbox" name="dark_mode_toggle" id="dark_mode_toggle" @click="toggleDarkMode" :checked="isDarkMode">
        <span class="toggler round"></span>
    </label>
    <i class='fa fa-moon'></i>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useUIStore } from '~/store/uiStore';

const uiStore = useUIStore();

// Use computed to always get the current value of uiStore.darkMode
const isDarkMode = computed(() => uiStore.darkMode);

const toggleDarkMode = () => {
  uiStore.toggleDarkMode();
}
</script>

<style scoped lang="scss">
@import '~/assets/constants.scss';

.toggle {
  position: relative;
  display: inline-block;
  width: 4.2857rem;  // 60px/14
  height: 2.4286rem; // 34px/14
  z-index: 998;
}

.toggle input {
  display: none;
}

input:checked + .toggler {
   background: linear-gradient(to bottom, $fa-orange, $fa-dark-orange);
}

input:focus + .toggler {
  box-shadow: 0 0 2px $fa-orange;
}
// Default (unchecked) state
.toggler::before {
  transform: translateX(-0.9rem);
}

// Checked state
input:checked + .toggler::before {
  transform: translateX(0.9rem);
}



.toggler {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: $dark-mode-background;
  transition: 0.4s;
}

.toggle-wrapper {
  position: absolute;
  right: 1rem;
  margin-top: 1rem;
  z-index: 989;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toggler {
  display: flex;
  justify-content: center; // Center horizontally
  align-items: center;     // Center vertically
  
  &.round {
    border-radius: 3rem;
    
    &::before {
      border-radius: 50%;
    }
  }
  
  &::before {
    position: relative;
    content: "";
    height: 1.8571rem; 
    width: 1.8571rem;  
    background: $light-white;
    transition: 0.4s;
  }
}


.light-mode {
  .dark-mode-sun, .dark-mode-moon {
    color: $fa-orange;
  }
  
  .toggler.round {
    box-shadow: 0px 0px 0.0714rem 0.1429rem $fa-orange; // 1px/14, 2px/14
  }
}

.dark-mode-moon, .dark-mode-sun {
  color: $light-white;
  z-index: 998;
}

.dark-mode-moon::before, .dark-mode-sun::before{
  font-family: 'FontAwesome';
  color: $light-white;
  font-weight: 900;
  z-index: 990;
  position: relative;
}

.dark-mode-sun::before {
  content: "\f185";
}

.dark-mode-moon::before {
  content: "\f186";
}


</style>
